import { Link, Icon, Alert, AlertTypography, Stack } from '@ace-clublabs/shared-component-library';
import { useState, JSX } from 'react';
import { GreenBoxModal } from './GreenBoxModal';
import { useGlobalState } from '../../state/state';
import { IGreenBoxMessage, MSSNotificationType } from '@lib/types';
import { Notification } from '../Notifications/Notifications';

export const GreenBoxMessage: (props: IGreenBoxMessage) => JSX.Element = ({
  shortBoxMessage,
  modalTitle,
  modalBody,
}) => {
  // const [content] = useGlobalState('content');
  const [showGreenBoxModal, setShowGreenBoxModal] = useState(false);

  if (!shortBoxMessage) return <></>;

  let leftSplit = '';
  let rightSplit = '';
  let middleSplit = '';
  const includesBoldTags = shortBoxMessage.includes('<b>') && shortBoxMessage.includes('</b>');

  if (includesBoldTags) {
    leftSplit = shortBoxMessage.split('<b>')[0];
    rightSplit = shortBoxMessage.split('</b>')[1];
    middleSplit = shortBoxMessage.split('<b>')[1].split('</b>')[0];
  }

  const Message = () => {
    if (includesBoldTags) {
      return (
        <>
          {leftSplit}
          <strong>{middleSplit}</strong> {rightSplit}
        </>
      );
    }
    return <>{shortBoxMessage}</>;
  };

  return (
    <Notification
      type={MSSNotificationType.SUCCESS}
      message={(<Message />) as any}
      iconOverride={'tag-regular'}
      modalTitle={modalTitle}
      modalBody={modalBody}
    />
  );
};
